<div class="container">
  @if (isSelfAuthoringRoleplay()) {
    <qai-accordian-panel [isExpandable]="true" [draggable]="true" [initialExpanded]="false" (expandedChange)="onExpandedChange($event)">
      @if (!isEditingName) {
        <qai-label accordianTitle kind="secondary" size="medium" weight="bold">{{ sectionTitle }}</qai-label>
      } @else {
        <input
          #nameInput
          accordianTitle
          qai-input
          class="section-name-input"
          [formControl]="sectionNameControl"
          (blur)="stopEditingName()"
          (keydown.enter)="handleNameInputKeydown($event)"
        />
      }
      <!-- @if (reviewSuggested() && !isEditingName) {
        <qai-badge
          accordianTitle
          class="review-suggested-badge"
          [shape]="'round'"
          [kind]="'yellow'"
          [size]="'xsmall'"
          [label]="'simulationBuilder.REVIEW_REQUIRED_LABEL' | transloco"
        ></qai-badge>
      } -->

      <div accordianControls class="accordian-controls">
        <span class="facts-count">
          {{ messagingFactSectionFacts.length }} {{ (messagingFactSectionFacts.length === 1 ? 'simulationBuilder.FACT_SINGULAR' : 'simulationBuilder.FACT_PLURAL') | transloco }}
        </span>
        <button class="icon-btn" (click)="startEditing()" [disabled]="readOnly">
          <qai-icon kind="pencil-edit" [color]="'var(--button-primary-bg-default)'" [size]="'16px'" />
        </button>
        <button class="icon-btn" (click)="deleteTheme()" [disabled]="readOnly">
          <qai-icon kind="trash" [color]="'var(--button-primary-bg-default)'" [size]="'16px'" />
        </button>
      </div>

      <div accordianContent class="accordian-content-container">
        <qai-dragable
          [listId]="'facts-' + sectionUuid"
          [connectedTo]="otherThemeListIds"
          [items]="factsItems"
          [useDragHandle]="true"
          [dragHandleDisable]="readOnly"
          (itemsChange)="onFactsReordered($event)"
        >
          <ng-template #cardTemplate let-item>
            <div style="display: flex; align-items: center; gap: 8px;">
              <messaging-theme-fact-flat
                style="flex: 1;"
                [currentFact]="asFormGroup(item)"
                [factIndex]="factIndexOf(item)"
                [readOnly]="readOnly"
                [isLast]="factIndexOf(item) === messagingFactSectionFacts.length - 1"
                (deleteFactRequested)="deleteFact($event.index, $event.factUuid)"
              ></messaging-theme-fact-flat>
            </div>
          </ng-template>
        </qai-dragable>
      </div>

      <div accordianBottomControls class="new-message-button-position new-message-button-position--roleplay">
        <span #addMessageBtnWrapper>
          <button
            qai-button
            [shape]="'normal'"
            [kind]="'tertiary'"
            [size]="'medium'"
            (click)="addNewMessage()"
            [disabled]="readOnly || hasBlankFact()"
          >
            <qai-icon kind="plus" size="'20px'" positionStart />
            <span>{{ 'simulationBuilder.ADD_NEW_FACT' | transloco }}</span>
          </button>
        </span>
        <qai-tooltip
          *ngIf="hasBlankFact()"
          [qaiFloating]="addMessageBtnWrapper"
          [placement]="'above-center'"
          [events]="['hover']"
        >
          {{ 'simulationBuilder.BLANK_MESSAGE_TOOLTIP' | transloco }}
        </qai-tooltip>
      </div>
    </qai-accordian-panel>
  } @else {
    <qai-accordian-panel>
      <span *ngIf="!isEditingName" accordianTitle class="section-title-text">{{ sectionTitle }}</span>
      <input
        *ngIf="isEditingName"
        #nameInput
        accordianTitle
        qai-input
        class="section-name-input"
        [formControl]="sectionNameControl"
        (blur)="stopEditingName()"
        (keydown.enter)="handleNameInputKeydown($event)"
      />

      <div accordianControls class="accordian-controls">
        <button class="icon-btn" (click)="startEditing()" [disabled]="readOnly">
          <qai-icon kind="pencil-edit" [color]="'#616161'" [size]="'16px'" />
        </button>
        <button class="icon-btn" (click)="deleteTheme()" [disabled]="readOnly">
          <qai-icon kind="trash" [color]="'#616161'" [size]="'16px'" />
        </button>
      </div>

      <div accordianContent class="accordian-content-container">
        <qai-dragable
          [listId]="'facts-' + sectionUuid"
          [connectedTo]="otherThemeListIds"
          [items]="factsItems"
          [useDragHandle]="true"
          [dragHandleDisable]="readOnly"
          (itemsChange)="onFactsReordered($event)"
        >
          <ng-template #cardTemplate let-item>
            <div style="display: flex; align-items: center; gap: 8px;">
              <messaging-theme-message
                style="flex: 1;"
                [currentFact]="asFormGroup(item)"
                [sectionUuid]="sectionUuid!"
                [factIndex]="factIndexOf(item)"
                (deleteFactRequested)="deleteFact($event.index, $event.factUuid)"
              ></messaging-theme-message>
            </div>
          </ng-template>
        </qai-dragable>
      </div>

      <div accordianBottomControls class="new-message-button-position">
        <button
          qai-button
          [shape]="'normal'"
          [kind]="'tertiary-text'"
          [size]="'medium'"
          (click)="addNewMessage()"
          [disabled]="readOnly || hasBlankFact()"
        >
          <qai-icon kind="plus" size="'20px'" positionStart />
          <span>{{ 'simulationBuilder.ADD_MESSAGE_BUTTON' | transloco }}</span>
        </button>
      </div>
    </qai-accordian-panel>
  }
</div>
